export default {"src":"/_next/static/media/building.45ed4453.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};